/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MessageResponseDtoAttachmentsInner
 */
export interface MessageResponseDtoAttachmentsInner {
    /**
     * 
     * @type {string}
     * @memberof MessageResponseDtoAttachmentsInner
     */
    url?: string;
    /**
     * 
     * @type {string}
     * @memberof MessageResponseDtoAttachmentsInner
     */
    filename?: string;
    /**
     * 
     * @type {string}
     * @memberof MessageResponseDtoAttachmentsInner
     */
    mimeType?: string;
    /**
     * 
     * @type {number}
     * @memberof MessageResponseDtoAttachmentsInner
     */
    size?: number;
    /**
     * Duration in seconds for audio/video files
     * @type {number}
     * @memberof MessageResponseDtoAttachmentsInner
     */
    duration?: number;
    /**
     * Thumbnail URL for video files
     * @type {string}
     * @memberof MessageResponseDtoAttachmentsInner
     */
    thumbnail?: string;
}

/**
 * Check if a given object implements the MessageResponseDtoAttachmentsInner interface.
 */
export function instanceOfMessageResponseDtoAttachmentsInner(value: object): value is MessageResponseDtoAttachmentsInner {
    return true;
}

export function MessageResponseDtoAttachmentsInnerFromJSON(json: any): MessageResponseDtoAttachmentsInner {
    return MessageResponseDtoAttachmentsInnerFromJSONTyped(json, false);
}

export function MessageResponseDtoAttachmentsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): MessageResponseDtoAttachmentsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'url': json['url'] == null ? undefined : json['url'],
        'filename': json['filename'] == null ? undefined : json['filename'],
        'mimeType': json['mimeType'] == null ? undefined : json['mimeType'],
        'size': json['size'] == null ? undefined : json['size'],
        'duration': json['duration'] == null ? undefined : json['duration'],
        'thumbnail': json['thumbnail'] == null ? undefined : json['thumbnail'],
    };
}

export function MessageResponseDtoAttachmentsInnerToJSON(json: any): MessageResponseDtoAttachmentsInner {
    return MessageResponseDtoAttachmentsInnerToJSONTyped(json, false);
}

export function MessageResponseDtoAttachmentsInnerToJSONTyped(value?: MessageResponseDtoAttachmentsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'url': value['url'],
        'filename': value['filename'],
        'mimeType': value['mimeType'],
        'size': value['size'],
        'duration': value['duration'],
        'thumbnail': value['thumbnail'],
    };
}

